import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import SendInvitationsSchema from "../../utils/SchemasValidation/SendInvitationsSchema";
import ValidateSchema from "../../helpers/ValidateSchema";
import classes from "../../assets/styles/CustomURLModal.module.css";
import { MdClose } from "react-icons/md";
import FormInput from "../Forms/FormInput";
import SecondLoader from "../SecondLoader";
import { trackEvent } from "../../utils/mixpanel";
const InvitationsAddModal = ({
  loading,
  data,
  setSelectedData,
  handleSaveShowModal,
  handleCloseModal,
  show,
}) => {
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setSelectedData({ ...data, [name]: value });
  };

  // handle Validation
  const validateForm = () => {
    let newErrors = ValidateSchema(data, SendInvitationsSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;
    return true;
  };

  const handleAddUrl = async (e) => {
    if (!validateForm()) return;

    handleSaveShowModal(data);
  };

  // Handle Update
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleCloseModal();
          setErrors({});
        }}
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header className="modalHeader justify-content-between">
          <span className="modalHeading">Send Invitation</span>
          <div
            className="modalGradientCircle"
            style={{ position: "absolute", top: "25px" }}
          ></div>
          <MdClose
            onClick={() => {
              handleCloseModal();
              setErrors({});
            }}
            className="modalCloseBtn"
          />
        </Modal.Header>
        {loading ? (
          <SecondLoader shortModal={true} />
        ) : (
          <>
            <Modal.Body>
              <div>
                <FormInput
                  type="text"
                  label="Email"
                  placeholder="Enter Email"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                  error={errors?.email}
                  autofocus={true}
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <div className="btnWrapper">
                <Button
                  type="button"
                  onClick={() => {
                    handleCloseModal();
                    setErrors({});
                  }}
                  variant="outline-primary"
                  className="cancelBtn m-3"
                >
                  Cancel
                </Button>

                <Button variant="primary" type="button" onClick={handleAddUrl}>
                  Send Invitation
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default InvitationsAddModal;
